<template>
    <page :tabs="tabs" :busy="busy">
        <grid
            :fetchCallback="fetchCallback"
            ref="grid"
            :columnDefs="columnDefs"
        >
            <responsive-button
                variant="primary"
                :icon="['fas', 'arrows-rotate']"
                @click="refresh"
                title="Refresh"
            >
                Refresh</responsive-button
            >
        </grid>
    </page>
</template>

<script>
import API from '../../api';
import Grid from '../generic/grid/grid.vue';
import Page from '../generic/page/page.vue';
import { CALENDAR_TAPE_DYNAMIC_PRICING_LOGS_LIST_ENDPOINT } from '../../endpoints';
import ResponsiveButton from '../generic/responsive-button/responsive-button.vue';
export default {
    components: { Page, Grid, ResponsiveButton },
    name: 'DynamicPricingLogsPage',
    data() {
        return {
            items: [],
            busy: null,
            offset: 0,
            limit: 20,
            sort: 'id',
            desc: false,
            search: '',
            columnDefs: [
                {
                    field: 'created',
                    headerName: 'Timestamp',
                    maxWidth: 200,
                    sort: 'desc',
                },
                {
                    field: 'partner_name',
                    headerName: 'Service',
                    flex: 1,
                },
                {
                    field: 'operation',
                    headerName: 'Operation',
                    flex: 1,
                },
                {
                    field: 'property_id',
                    headerName: 'Property #',
                    flex: 1,
                },
                {
                    field: 'property_name',
                    headerName: 'Property Name',
                    flex: 1,
                },
            ],
            tabs: [
                {
                    title: 'Beyond Pricing',
                    active: false,
                    route: '/app/pricing/beyond/',
                },
                {
                    title: 'Price Labs',
                    active: false,
                    route: '/app/pricing/labs/',
                },
                {
                    title: 'Logs',
                    active: true,
                    route: '/app/pricing/logs/',
                },
            ],
        };
    },
    computed: {
        fetchCallback() {
            return ({ offset, limit, sort, desc, search }) => {
                this.offset = offset;
                this.limit = limit;
                this.sort = sort;
                this.desc = desc;
                this.search = search;
                return API.get('/app/pricing/dynamic-pricing-log/grid/', {
                    params: {
                        offset,
                        limit,
                        sort,
                        desc,
                        search,
                    },
                });
            };
        },
    },
    methods: {
        refresh() {
            this.$refs.grid.refreshDataSource();
        },
    },
};
</script>